import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-up-left', 'ArrowLongUpLeft', [["path",{"d":"M5 11V5m0 0h6M5 5l14 14","key":"svg-0"}]]);